<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import IssueForm from '../IssueForm.vue';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    IssueForm,
    PageHeader,
    Spinner,
  },
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    issueData() {
      const { issueId } = this.$route.params;
      return this.$store.getters['issues/getIssue'](issueId);
    },
    showIssueForm() {
      const { id } = this.issueData;
      return id && !this.uiFlags.isFetching;
    },
    ...mapGetters({
      uiFlags: 'issues/getUIFlags',
    }),
  },
  methods: {
    async updateIssue(data) {
      try {
        const { issueId } = this.$route.params;

        await this.$store.dispatch('issues/update', {
          id: issueId,
          ...data,
        });

        router.replace({
          name: 'settings_issues_edit_members',
          params: {
            page: 'edit',
            issueId,
          },
        });
      } catch (error) {
        useAlert(this.$t('ISSUES_SETTINGS.ISSUE_FORM.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6">
    <PageHeader
      :header-title="$t('ISSUES_SETTINGS.EDIT_FLOW.CREATE.TITLE')"
      :header-content="$t('ISSUES_SETTINGS.EDIT_FLOW.CREATE.DESC')"
    />
    <div class="flex flex-wrap">
      <IssueForm
        v-if="showIssueForm"
        :on-submit="updateIssue"
        :submit-in-progress="false"
        :submit-button-text="$t('ISSUES_SETTINGS.EDIT_FLOW.CREATE.BUTTON_TEXT')"
        :form-data="issueData"
      />
      <Spinner v-else />
    </div>
  </div>
</template>
